import { Tooltip as MuiTooltip } from '@mui/material'
import { getTooltipTitleSx } from './tooltipTitleSx.js'

export default function Tooltip({
  text,
  children,
  placement = 'top',
  allowWrap = false,
  maxLines,
  bubbleMaxWidth,
  rootClassName = '',
}) {
  return (
    <MuiTooltip
      describeChild
      title={text || ''}
      placement={placement}
      disableHoverListener={!text}
      disableFocusListener={!text}
      disableTouchListener={!text}
      slotProps={{
        tooltip: {
          className: rootClassName,
          sx: getTooltipTitleSx({ allowWrap, maxLines, bubbleMaxWidth }),
        },
        popper: {
          popperOptions: {
            modifiers: [
              {
                name: 'offset',
                options: { offset: [0, placement === 'bottom' ? 6 : -6] },
              },
            ],
          },
        },
      }}
    >
      {children}
    </MuiTooltip>
  )
}
